import { useEffect, useState } from 'react';
import { ErrorService, ErrorServiceEventNames } from '../services/errorService';
import { FetchError } from '../utilities/error';

export function useErrorService(service: ErrorService): FetchError[] {
  const [errors, setErrors] = useState<FetchError[]>([]);

  useEffect(() => {
    const onCatchError = () => {
      setErrors(service.errors);
    };

    service.addEventListener(ErrorServiceEventNames.CATCH_ERROR, onCatchError);

    return () => service.removeEventListener(ErrorServiceEventNames.CATCH_ERROR, null);
  }, []);

  return errors;
}
